import React, { useEffect, useState } from 'react';
import styles from './RangeAnalysisTab.module.css';
import useHttp from '../../../../hook/use-http';
import { useRangeAnalysisVehicleData } from './Context';
import { Download } from 'lucide-react';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import useExcelDownload from '../../../../hook/useExelDownload';

let initialObj = {
  "Energy_Efficiency": null,
  "SOC": null,
  "dischargeDistanceKm": null,
  "dischargeTotalKWhConsumed": null,
  "percentageRegen": null,
  "percentageTimeSpentInAcc_pedal_position_1_20_40": null,
  "percentageTimeSpentInMotorspeed_1000_2000": null,
  "percentageTimeSpentInSpeed_0": null,
  "percentageTimeSpentInSpeed_30_50": null,
  "percentageTimeSpentInCoasting_1": null,
  "vehicleId": null,
}

let initialData = Array.from({ length: 5 }, () => (initialObj))

const TopVehicles = () => {

  const { isLoading, error, sendReq: fetchData } = useHttp();
  const { GlobalData, setGlobalData } = useRangeAnalysisVehicleData()
  const downloadExcel = useExcelDownload();
  const [canDownload, setCanDownload] = useState(false)


  const [topVehiclesData, setTopVehiclesData] = useState(initialData)
  const [SelectedVehicle, setSelectedVehicle] = useState(initialObj)


  useEffect(() => {
    setCanDownload(false)
    fetchData({ url: API_URL_MAIN + `mileage_saarthi_range/top5_vehicles`, body: { filterdata: GlobalData } },
      (data) => {
        if (data.length) {
          setTopVehiclesData(data)
          setSelectedVehicle({ ...data?.[0], activeIndex: 0 })
          setCanDownload(true)
        }
        else {
          setSelectedVehicle(initialObj)
          setTopVehiclesData(initialData)
          setCanDownload(false)
        }
      }
    )
  }, [GlobalData])

  const selectVehicleHandle = (index) => {
    let selectedCardData = topVehiclesData?.[index]
    setSelectedVehicle({ ...selectedCardData, activeIndex: index })
  }

  const handleDownloadReport = () => {


    let data = topVehiclesData?.map(item => (
      {
        "Vehicle Id": item?.vehicleId !== null ? item?.vehicleId : "--",
        "Energy Efficiency": item?.Energy_Efficiency !== null ? item?.Energy_Efficiency?.toFixed(2) + " kWh/km" : "--",
        "SOC": item?.SOC !== null ? item?.SOC?.toFixed(2) + " %" : "--",
        "Distance": item?.dischargeDistanceKm !== null ? item?.dischargeDistanceKm + " km" : "--",
        "Energy Consumption": item?.dischargeTotalKWhConsumed !== null ? item?.dischargeTotalKWhConsumed?.toFixed(2) + " kWh" : "--",
        "Regeneration": item?.percentageRegen !== null ? item?.percentageRegen?.toFixed(2) + " %" : "--",
        "Acc. Ped. Position": item?.percentageTimeSpentInAcc_pedal_position_1_20_40 !== null ? item?.percentageTimeSpentInAcc_pedal_position_1_20_40?.toFixed(2) + '%' : "--",
        "RPM": item?.percentageTimeSpentInMotorspeed_1000_2000 !== null ? item?.percentageTimeSpentInMotorspeed_1000_2000?.toFixed(2) + " %" : "--",
        "Idling": item?.percentageTimeSpentInSpeed_0 !== null ? item?.percentageTimeSpentInSpeed_0?.toFixed(2) + " %" : "--",
        "Coasting": item?.percentageTimeSpentInCoasting_1 !== null ? item?.percentageTimeSpentInCoasting_1?.toFixed(2) + " %" : "--",
        "Speed": item?.percentageTimeSpentInSpeed_30_50 !== null ? item?.percentageTimeSpentInSpeed_30_50?.toFixed(2) + " %" : "--",
      }
    ))

    downloadExcel(data, "Top 5 Vehicles")
  }


  return (
    <div className="card mb-4">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className={`card-title ${styles.cardTitle}`}>{'Top 5 Vehicles'}</h5>
          <button
            className={`d-flex align-items-center gap-2 border-0 bg-transparent ${canDownload ? "text-primary custom-Btn-animation" : "text-secondary"} ${styles.brandColor}`}
            onClick={canDownload ? handleDownloadReport : ""}
          >
            <Download size={16} />
            <span className="fw-bold">Download</span>
          </button>
        </div>
        <div className="row">
          {/* Left side - Vehicle rankings */}
          <div className="col-md-4">
            {topVehiclesData.map((vehicle, index) => (
              <div key={index} className={`card ${SelectedVehicle.activeIndex == index ? styles.vehicleRankActive : styles.vehicleRankCard}`} onClick={() => selectVehicleHandle(index)}>
                <div className={`card-body ${styles.vehicleRankCardBody}`}>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <span className={`badge me-2 ${styles.rankBadge}`}>
                        {index + 1}
                      </span>
                      <div>
                        <div className={styles.vehicleRankText}>{"Rank Vehicle"}</div>
                        <small className={styles.vehicleRankSubtext}>SOC Consumed: {vehicle.SOC !== null ? parseFloat(vehicle.SOC?.toFixed(2)) + "%" : "--"}</small>
                      </div>
                    </div>
                    <div className="text-end">
                      <div className={styles.energyEfficiencyText}>{vehicle.Energy_Efficiency !== null ? vehicle.Energy_Efficiency?.toFixed(2) : "--"} kWh/km</div>
                      <small className={styles.energyEfficiencySubtext}>Energy Efficiency</small>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* Right side - Performance metrics */}
          <div className="col-md-8">
            <div className={`card ${styles.metricsCard}`}>
              <div className={`card-body ${styles.metricsCardBody}`}>
                <div className="d-flex justify-content-between align-items-start">
                  {/* Main metrics - left side */}
                  <div className={`d-flex flex-column justify-content-between w-50`}>
                    <div className={`  text-center ${styles.performanceIndicatorCardTransparent}`}>
                      <h3 className={`${styles.mainMetricSmall} mt-3`}>{SelectedVehicle?.dischargeDistanceKm !== null ? parseFloat(SelectedVehicle?.dischargeDistanceKm?.toFixed(2)) : "--"}</h3>
                      <small className={styles.mainMetricLabel}>km</small>
                    </div>

                    <div className={` mt-3 text-center ${styles.performanceIndicatorCardTransparent}`}>
                      <h3 className={`${styles.mainMetricSmall} mt-3`}>{SelectedVehicle?.dischargeTotalKWhConsumed !== null ? parseFloat(SelectedVehicle?.dischargeTotalKWhConsumed?.toFixed(2)) + " kWh" : "--"}</h3>
                      <small className={styles.mainMetricLabel}>Energy Consumption</small>
                    </div>

                    <div className={` mt-3 text-center ${styles.performanceIndicatorCardTransparent}`}>
                      <h3 className={`${styles.mainMetricSmall} mt-3`}>{SelectedVehicle?.Energy_Efficiency !== null ? parseFloat(SelectedVehicle?.Energy_Efficiency?.toFixed(2)) + " kWh/km" : "--"} </h3>
                      <small className={styles.mainMetricLabel}>Energy Efficiency</small>
                    </div>
                  </div>
                  {/* Performance indicators - right side */}
                  <div className="row g-3 flex-fill ms-3">
                    <div className="col-6">
                      <div className={`card text-center ${styles.performanceIndicatorCard}`}>
                        <div className="card-body py-2 d-flex flex-column justify-content-center">
                          <img src='/assets/ms_bus/range_analysis/speed.png' className='mx-auto' height={20} width={20} />
                          {/* <i className={`fas fa-tachometer-alt ${styles.performanceIndicatorIcon}`}></i> */}
                          <div className={styles.performanceIndicatorTitle}>Speed</div>
                          <small className={`text-muted ${styles.performanceIndicatorValue}`}>Achieved Value: {SelectedVehicle?.percentageTimeSpentInSpeed_30_50 !== null ? SelectedVehicle?.percentageTimeSpentInSpeed_30_50?.toFixed(2) + "%" : "--"}</small>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className={`card text-center ${styles.performanceIndicatorCard}`}>
                        <div className="card-body py-2 d-flex flex-column justify-content-center">
                          <img src='/assets/ms_bus/range_analysis/acceleration_pedal_position.png' className='mx-auto' height={20} width={20} />
                          {/* <i className={`fas fa-sliders-h ${styles.performanceIndicatorIcon}`}></i> */}
                          <div className={styles.performanceIndicatorTitle}>Acc. Ped. Position</div>
                          <small className={`text-muted ${styles.performanceIndicatorValue}`}>Achieved Value: {SelectedVehicle?.percentageTimeSpentInAcc_pedal_position_1_20_40 !== null ? SelectedVehicle?.percentageTimeSpentInAcc_pedal_position_1_20_40?.toFixed(2) + "%" : "--"}</small>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className={`card text-center ${styles.performanceIndicatorCard}`}>
                        <div className="card-body py-2 d-flex flex-column justify-content-center">
                          <img src='/assets/ms_bus/range_analysis/rpm.png' className='mx-auto' height={20} width={20} />
                          {/* <i className={`fas fa-cog ${styles.performanceIndicatorIcon}`}></i> */}
                          <div className={styles.performanceIndicatorTitle}>RPM Band</div>
                          <small className={`text-muted ${styles.performanceIndicatorValue}`}>Achieved Value: {SelectedVehicle?.percentageTimeSpentInMotorspeed_1000_2000 !== null ? SelectedVehicle?.percentageTimeSpentInMotorspeed_1000_2000?.toFixed(2) + "%" : "--"}</small>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className={`card text-center ${styles.performanceIndicatorCard}`}>
                        <div className="card-body py-2 d-flex flex-column justify-content-center">
                          <img src='/assets/ms_bus/range_analysis/regeneration.png' className='mx-auto' height={20} width={20} />
                          {/* <i className={`fas fa-recycle ${styles.performanceIndicatorIcon}`}></i> */}
                          <div className={styles.performanceIndicatorTitle}>Regeneration</div>
                          <small className={`text-muted ${styles.performanceIndicatorValue}`}>Achieved Value: {SelectedVehicle?.percentageRegen !== null ? SelectedVehicle?.percentageRegen?.toFixed(2) + "%" : "--"}</small>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className={`card text-center ${styles.performanceIndicatorCard}`}>
                        <div className="card-body py-2 d-flex flex-column justify-content-center">
                          <img src='/assets/ms_bus/range_analysis/idling.png' className='mx-auto' height={20} width={20} />
                          {/* <i className={`fas fa-pause-circle ${styles.performanceIndicatorIcon}`}></i> */}
                          <div className={styles.performanceIndicatorTitle}>Idling</div>
                          <small className={`text-muted ${styles.performanceIndicatorValue}`}>Achieved Value: {SelectedVehicle?.percentageTimeSpentInSpeed_0 !== null ? SelectedVehicle?.percentageTimeSpentInSpeed_0?.toFixed(2) + "%" : "--"}</small>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className={`card text-center ${styles.performanceIndicatorCard}`}>
                        <div className="card-body py-2 d-flex flex-column justify-content-center">
                          <img src='/assets/ms_bus/range_analysis/coasting.png' className='mx-auto' height={20} width={20} />
                          {/* <i className={`fas fa-arrow-down ${styles.performanceIndicatorIcon}`}></i> */}
                          <div className={styles.performanceIndicatorTitle}>Coasting</div>
                          <small className={`text-muted ${styles.performanceIndicatorValue}`}>Achieved Value: {SelectedVehicle?.percentageTimeSpentInCoasting_1 !== null ? SelectedVehicle?.percentageTimeSpentInCoasting_1?.toFixed(2) + "%" : "--"}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopVehicles;